// extracted by mini-css-extract-plugin
module.exports = {"image":"d9","image-placeholder":"d-","imagePlaceholder":"d-"};